export default __webpack_public_path__ + "static/media/and-now-im-sad.185b8792.gif";